module.exports = __webpack_public_path__ + "Roboto-Medium.woff2?90d1676003d9c28c04994c18bfd8b558";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Medium/Roboto-Medium.woff2?v=2.137
// module id = 677
// module chunks = 7